import { useEffect, useState } from 'react';
import { auth } from '../auth';
export const useIsAuthenticated = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    useEffect(() => {
        (async () => {
            const result = await auth.isAuthenticated;
            if (result.isOk()) {
                setIsAuthenticated(true);
            }
            setIsLoading(false);
        })();
    }, []);
    return [isLoading, isAuthenticated];
};
